module.exports = __webpack_public_path__ + "static/media/felicity-jones-lose.128d2c04.jpg";